<template>
    <v-container>
        <div class="text-left" style="margin-bottom:20px;">
            <router-link to="/janvegas">
                <v-btn
                    color="secondary"
                    class="text-right"
                    style="width:250px"
                >
                    Back
                </v-btn>
            </router-link>
        </div>          
        <v-row>   
            <v-col cols="9">
                <div class="text-left">
                    <p>Denver Omlette with fruit $26 + $2.18 Tax + $5 tip</p>
                    <img alt="Breakfast Fruit Platter" class="uitk-image-media" src="/vegasjan/29Breakfast.jpeg" style="width: 17%; height: auto;">     
                </div>
                <div class="text-left" style="margin-top:20px;">
                    <b>Lunch</b>
                    <p>Ham and cheese criossant $10.99 + $0.92 tax + $5 tip</p>
                    <img alt="Lunch" class="uitk-image-media" src="/vegasjan/29Lunch.jpeg" style="width: 17%; height: auto;">                
                </div>        
                <div class="text-left" style="margin-top:20px;">
                    <p>Peacan Pie it is very large only ate some of it</p>
                    <p>$16.95 + $1.42 tax + $15 tip</p>
                    <img alt="Peacan pie" class="uitk-image-media" src="/vegasjan/29Lunch-2.jpeg" style="width: 17%; height: auto;">                
                </div>  
                <div class="text-left" style="margin-top:20px;">
                    <b>Dinner</b>
                    <p>You have seen it before, I will get the shepherds pie and a number of ciders</p>
                </div>                                             
            </v-col>
            <v-col cols="3">
            </v-col>
            <v-col cols="9">
                <div class="text-left">
                    <p>Some gambling and drinking occurred among other things.</p>
                </div>  
                <div class="text-left">
                    <p>Stock market open not much happening yet ... good day to hold.</p>
                </div>
            </v-col>               
        </v-row>
    </v-container>
  </template>